export default "__VITE_ASSET__Dg6w_YAD__"